import {
  useOptionsRegistrationSuspenseQuery,
  OptionsRegistrationDocument,
  useOrUpdateMutation,
} from '../../../../../graphql/react-operations';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { BvContactForm } from '../../../../../components/BvContactForm';
import { useStepper } from '../../../../../components/steppers/common/StepperContext';

export const StepRegForm = ({ orId }: { orId: string }) => {
  const companyId = useCompanyId();
  const { stepNext } = useStepper();

  const [updateOr, { loading, error }] = useOrUpdateMutation({ refetchQueries: [OptionsRegistrationDocument] });
  const { data } = useOptionsRegistrationSuspenseQuery({ variables: { id: orId } });

  return (
    <BvContactForm
      loading={loading}
      error={error}
      onSave={async input => {
        await updateOr({
          variables: {
            companyId,
            input: { ...input, id: orId },
          },
        });
        await stepNext();
      }}
      defaultValues={{
        contact: data.optionsRegistration.contact,
        signatory: data.optionsRegistration.signatory,
        regFormPaymentThroughBolago: data.optionsRegistration.regFormPaymentThroughBolago,
      }}
    />
  );
};
